import * as React from "react";

const SvgIcnQueue = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M6 10c1.271 0 2.305.38 3.071 1.146.467.467.722.773.888 1.156a.5.5 0 01-.918.396c-.098-.225-.3-.469-.677-.844C7.797 11.287 7.021 11 6.005 11c-.87.009-1.578.296-2.152.869-.563.563-.853 1.43-.852 2.632a.5.5 0 11-1 0c-.001-1.446.374-2.569 1.146-3.34.76-.76 1.719-1.15 2.846-1.161h.002a3 3 0 11.006 0zm9.502 3c2.122 0 3.748.542 4.853 1.646C21.46 15.751 22.002 17.378 22 19.5a.5.5 0 01-1 0c.001-1.878-.456-3.25-1.352-4.146-.896-.896-2.27-1.354-4.146-1.354H15.5c-1.877 0-3.25.458-4.147 1.354-.896.895-1.353 2.268-1.351 4.146a.5.5 0 01-1 0c-.002-2.122.54-3.75 1.645-4.854C11.75 13.542 13.378 13 15.5 13zm-.002-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 1a4.5 4.5 0 110-9 4.5 4.5 0 010 9zM6 9a2 2 0 100-4 2 2 0 000 4z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnQueue;
